import { Grid } from '@material-ui/core'
import React, { useState } from 'react'
import { useContractStore } from 'context/ContractStore'
import { AsterToggleButton, AsterToggleButtonGroup } from 'asterX-UI/Buttons/toggle-button'
import { ContentCard } from 'components/ContentCard/ContentCard'
import { CardCheckbox } from 'components/CardCheckbox/CardCheckbox'
import { PledgeCard } from 'components/PledgeCard/PledgeCard'

import { NotFound } from 'components/NotFound/NotFound'
import { useStyles } from './contract.styles'
import {
  contractTypes,
  getCreditProductCheckboxData,
  getCreditProductData,
  getProcuringData,
  getRequestData
} from './const'

export const Contract = () => {
  const classes = useStyles()
  const {
    contractStore: { contract }
  } = useContractStore()

  const [activeTab, setActiveTab] = useState('request')

  return (
    <Grid container className={classes.wrapper}>
      <Grid item container className={classes.tableFilter}>
        <AsterToggleButtonGroup
          exclusive
          value={activeTab}
          onChange={(e, val) => {
            setActiveTab(val)
          }}
        >
          {contractTypes.map(({ label, code }, i) => (
            <AsterToggleButton key={`table-toggle-btn-${code}`} value={code}>
              {label}
            </AsterToggleButton>
          ))}
        </AsterToggleButtonGroup>
      </Grid>

      {activeTab === 'request' && (
        <>
          <Grid item container className={classes.contentCard}>
            <ContentCard data={getRequestData(contract)} line />
          </Grid>
        </>
      )}

      {activeTab === 'creditProduct' && (
        <>
          <Grid item container className={classes.contentCard}>
            <ContentCard data={getCreditProductData(contract)} line />
          </Grid>
          <Grid item container className={classes.contentCard}>
            <CardCheckbox data={getCreditProductCheckboxData(contract)} line />
          </Grid>
        </>
      )}

      {activeTab === 'procuring' && (
        <>
          {[101754, 101760, 101762, 101757, 101753].includes(contract?.collateralTypeId) ? (
            <Grid item container className={classes.contentCard}>
              <PledgeCard sections={getProcuringData(contract)} contract={contract} />
            </Grid>
          ) : (
            <Grid item container className={classes.contentCard}>
              <NotFound title="Нет залога" />
            </Grid>
          )}
        </>
      )}
    </Grid>
  )
}
